import { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";

const fmt = (s) => (isFinite(s) ? `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}` : "0:00");
const BAR_COUNT = 48;
const BARS = Array.from({ length: BAR_COUNT }, (_, i) => ({ id: `bar-${i}`, pos: i / BAR_COUNT, h: 25 + Math.abs(Math.sin(i * 1.7) * 55) + (i % 5) * 4 }));

export const AudioPlayer = ({ src, label = "30-sec preview", testid = "audio-preview" }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [t, setT] = useState(0);
  const [d, setD] = useState(0);
  const [failed, setFailed] = useState(false);
  const toggle = () => {
    const a = ref.current;
    if (!a.paused) return a.pause();
    setFailed(false);
    const pr = a.play();
    if (pr) pr.catch((e) => { if (e?.name !== "AbortError") { setFailed(true); setPlaying(false); } });
  };
  const seek = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    ref.current.currentTime = ((e.clientX - r.left) / r.width) * d;
  };
  return (
    <div className="wb-card p-5" style={{ borderColor: "var(--wb-line-accent)" }} data-testid={`${testid}-player`}>
      <audio
        ref={ref} src={src} preload="metadata"
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)}
        onTimeUpdate={(e) => setT(e.target.currentTime)} onLoadedMetadata={(e) => setD(e.target.duration)}
        onError={() => { setFailed(true); setPlaying(false); }}
        data-testid={`${testid}-element`}
      />
      <div className="flex items-center gap-5">
        <button
          onClick={toggle} data-testid={`${testid}-play-button`} aria-label={playing ? "Pause" : "Play"}
          className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-wb-gold text-[color:var(--wb-on-gold)] transition-transform duration-200 hover:scale-105"
        >
          {playing ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
        </button>
        <div className="flex-1">
          <div className="mb-2 flex justify-between font-mono text-[0.65rem] uppercase tracking-[0.2em] muted">
            <span>{label}</span><span>{fmt(t)} / {fmt(d)}</span>
          </div>
          <div className="flex h-8 cursor-pointer items-end gap-[3px]" onClick={seek} data-testid={`${testid}-seek-bar`}>
            {BARS.map((b) => {
              const on = d && b.pos < t / d;
              return <span key={b.id} className="flex-1 transition-colors duration-150" style={{ height: `${b.h}%`, background: on ? "var(--wb-gold)" : "var(--wb-line-strong)" }} />;
            })}
          </div>
        </div>
      </div>
      {failed && <p role="alert" className="mt-3 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-[#E07A6B]" data-testid={`${testid}-error`}>{label.includes("preview") ? "Preview" : "Audio"} couldn't play. Please try again.</p>}
    </div>
  );
};
